import { AccountCircleRounded } from "@mui/icons-material";
import FolderOpenRoundedIcon from "@mui/icons-material/FolderOpenRounded";
import { Box, Typography } from "@mui/material";
import SvgToIcon from "../../../../../../icons/SvgToIcon";
import { icons } from "../../../icons/iconExport";
import { ServerTypeIconsAndLabels, platformIcons } from "../../../utils";
import TextIntegrationStyle from "../../TextIntegrationStyle";

const AzureVirtualMachineDetailsView = ({ entityData }) => {
  const ServerTypeLogo = (type) => {
    if (Object.keys(ServerTypeIconsAndLabels).includes(type)) {
      const [icon] = ServerTypeIconsAndLabels[type];
      return icon;
    }
    return null;
  };

  const ServerTypeLabel = (type) => {
    if (Object.keys(ServerTypeIconsAndLabels).includes(type)) {
      const [, label] = ServerTypeIconsAndLabels[type];
      return label;
    }
    return null;
  };

  return (
    <Box display="flex" flexDirection="column" gap={2}>
      {entityData?.azure_vm_data?.subscription_name && (
        <Box display="flex" flexDirection="column" gap={1}>
          <Box display="flex" flexDirection="row" alignItems="center" gap={1}>
            <AccountCircleRounded sx={{ width: "16px" }} />
            <Typography variant="subtitle2">Subscription Name</Typography>
          </Box>
          <Box ml={2} display="flex">
            <TextIntegrationStyle
              title=""
              value={entityData?.azure_vm_data?.subscription_name}
            ></TextIntegrationStyle>
          </Box>
        </Box>
      )}
      {entityData?.azure_vm_data?.resource_group_name && (
        <Box display="flex" flexDirection="column" gap={1}>
          <Box display="flex" flexDirection="row" alignItems="center" gap={1}>
            <FolderOpenRoundedIcon sx={{ width: "16px" }} />
            <Typography variant="subtitle2">Resource Group</Typography>
          </Box>
          <Box ml={2} display="flex">
            <TextIntegrationStyle
              title=""
              value={entityData?.azure_vm_data?.resource_group_name}
            ></TextIntegrationStyle>
          </Box>
        </Box>
      )}
      {entityData?.azure_vm_data?.resource_type && (
        <Box display="flex" flexDirection="column" gap={1}>
          <Box display="flex" flexDirection="row" alignItems="center" gap={1}>
            <SvgToIcon IconLogo={icons.serverTypeIcon} width="16px" />
            <Typography variant="subtitle2">Type</Typography>
          </Box>
          <Box ml={2} display="flex">
            <SvgToIcon
              IconLogo={ServerTypeLogo(entityData.azure_vm_data.resource_type)}
              width="16px"
            />
            <TextIntegrationStyle
              title=""
              value={ServerTypeLabel(entityData.azure_vm_data.resource_type)}
            ></TextIntegrationStyle>
          </Box>
        </Box>
      )}
      {entityData?.azure_vm_data?.location && (
        <Box display="flex" flexDirection="column" gap={1}>
          <Box display="flex" flexDirection="row" alignItems="center" gap={1}>
            <SvgToIcon IconLogo={icons.regionServerIcon} width="16px" />
            <Typography variant="subtitle2">Location</Typography>
          </Box>
          <Box ml={2} display="flex">
            <TextIntegrationStyle
              title=""
              value={entityData.azure_vm_data.location}
            ></TextIntegrationStyle>
          </Box>
        </Box>
      )}
      {entityData?.platform && (
        <Box display="flex" flexDirection="column" gap={1}>
          <Box display="flex" flexDirection="row" alignItems="center" gap={1}>
            <SvgToIcon IconLogo={icons.serverTypeIcon} width="16px" />
            <Typography variant="subtitle2">Operating System</Typography>
          </Box>
          <Box ml={2} display="flex" alignItems="center" gap={1}>
            {(() => {
              for (const [platform, icon] of Object.entries(platformIcons)) {
                if (
                  entityData.platform
                    .toLowerCase()
                    .includes(platform.toLowerCase())
                ) {
                  return <SvgToIcon IconLogo={icon} width="16px" />;
                }
              }
              return null;
            })()}
            <TextIntegrationStyle
              title=""
              value={entityData.platform}
            ></TextIntegrationStyle>
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default AzureVirtualMachineDetailsView;
